import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material';

@Injectable()
export class FuseMatSidenavHelperService
{
    sidenavInstances: MatSidenav[];

    constructor()
    {
        this.sidenavInstances = [];
    }

    setSidenav(id, instance)
    {
        this.sidenavInstances[id] = instance;
    }

    getSidenav(id)
    {
        return this.sidenavInstances[id];
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/core/directives/fuse-mat-sidenav-helper/fuse-mat-sidenav-helper.service.ts